import type { FunctionComponent } from 'react';
import { useIntl } from 'react-intl';

import { FormattedMessage } from '../../../../shared/components/formatted-message/formatted-message';
import { Gap } from '../../../../shared/components/gap/gap';
import { Icon } from '../../../../shared/components/icon/icon';
import { IconHover } from '../../../../shared/components/icon-hover/icon-hover';
import { slugify } from '../../../../shared/utils/strings';
import type { IAdditionalProperties } from '../../../transactions.interface';

export interface ISportsBetInformationProps {
    properties: IAdditionalProperties;
}

export const SportsBetInformation: FunctionComponent<ISportsBetInformationProps> = ({
    properties,
}) => {
    const intl = useIntl();
    const selections = properties.Sports?.Selections;
    const betType = properties.Sports?.Transaction?.BetType;
    const settlementStatus = properties.Sports?.Transaction?.SettlementStatus;
    const hasSelections = selections && selections.length > 0;

    const content = (
        <Gap direction="horizontal">
            <Gap>
                {betType ? (
                    <FormattedMessage
                        id={`transactions.sports-item.bet-type-${slugify(betType)}.label`}
                        defaultMessage={`Bet Type: ${betType}`}
                    />
                ) : null}
                {settlementStatus ? (
                    <FormattedMessage
                        id={`transactions.sports-item.settlement-status-${slugify(
                            settlementStatus,
                        )}.label`}
                        defaultMessage={`Settlement Type: ${settlementStatus}`}
                    />
                ) : null}
            </Gap>
            {hasSelections ? <Icon name={'info-circle'} /> : null}
        </Gap>
    );

    if (!hasSelections) {
        return content;
    }

    return (
        <IconHover
            hoverItem={content}
            infoDisplay={
                <Gap>
                    {selections.map((item) => {
                        return (
                            <div key={item?.EventId}>
                                <FormattedMessage
                                    id="transactions.sports-item.bet-details.game-name.info"
                                    defaultMessage="Game: {selectionName} <br></br>Odds: {odds} <br></br>Event Start Date: {eventStartDate} <br></br>Is Event Live: {IsLive}"
                                    values={{
                                        selectionName: item.SelectionName,
                                        odds: item.Odds,
                                        eventStartDate: item.EventStartDate,
                                        IsLive:
                                            item?.IsLive === 'False'
                                                ? intl.formatMessage({
                                                      id: 'transactions.sports-item.is-not-live.lable',
                                                      defaultMessage: 'No',
                                                  })
                                                : intl.formatMessage({
                                                      id: 'transactions.sports-item.is-live.lable',
                                                      defaultMessage: 'Yes',
                                                  }),
                                    }}
                                />
                            </div>
                        );
                    })}
                </Gap>
            }
        />
    );
};
